import { atom } from "jotai"

export const sourceCityAtom = atom([])
export const sourceCityListAtom = atom([])
export const destinationCityAtom = atom([])
export const destinationCityListAtom = atom([])


